import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM6.5 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 19a6.002 6.002 0 0 1-5.828-4.568 3.719 3.719 0 0 1-.054-.266A1 1 0 0 1 7.104 13h9.79a1 1 0 0 1 .986 1.163 3.95 3.95 0 0 1-.069.336A6.003 6.003 0 0 1 12 19zm0-1c2.295 0 4.28-1.56 4.843-3.75.016-.065.034-.149.05-.25H7.104c.013.077.026.142.04.194A5.002 5.002 0 0 0 12 18z"
});

var SvgReaction = function SvgReaction(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgReaction;